import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SignUp from './components/SignUp';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Home from './components/Home';
import GiftRedeem from "./pages/GiftRedeem";
import AdminFeedbackPanel from "./components/AdminFeedbackPanel"; // ✅ NEW

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/gift/redeem/:token" element={<GiftRedeem />} />

      {/* ✅ Admin panel (protected by backend admin middleware) */}
      <Route path="/admin" element={<AdminFeedbackPanel />} />
    </Routes>
  );
}

export default App;
